// --------------------- Import Global ---------------------
import axios from "axios";
import Globais, {
  validateToken,
  formatarData,
} from "../../../components/Globais";
import { formatDate } from "../../../uteis/dateUtils";

export const buscarRepresentanteService = async (
  cotaUsuarioId: number | null | undefined
) => {
  const Token = validateToken();
  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/representante/todos/cotausuario/${cotaUsuarioId}`;
    try {
      const response = await axios.get(URL, {
        headers: {
          Authorization: Token.AuthStr,
        },
      });

      if (response) {
        let representantes = response.data.filter((p: any) => {
          p.key = p.id;
          p.usuarioId = p.usuarioId;
          p.nome = `${p.UsuarioTable.nome} ${p.UsuarioTable.sobrenome}`;
          p.situacao = p.checked === 1 ? "Sim" : "Nao";

          p.dataInclusao = formatDate(p.created_at);
          p.dataAssinatura = p.dataAssinatura
            ? formatarData(p.dataAssinatura)
            : "";
          p.dataVencimento = p.dataVencimento
            ? formatarData(p.dataVencimento)
            : "";

          return p;
        });
        return representantes;
      }
    } catch (error) {
      console.error("Erro ao representantes:", error);
    }
  }
};
